export default __webpack_public_path__ + "static/media/check-icon.d3c3e33b.svg";